const eventBus = {
  listeners: new Map(),

  on(event, callback) {
    const wrappedCallback = (e) => callback(e.detail);
    this.listeners.set(callback, wrappedCallback);
    document.addEventListener(event, wrappedCallback);
  },

  dispatch(event, data) {
    document.dispatchEvent(new CustomEvent(event, { detail: data }));
  },

  remove(event, callback) {
    if (this.listeners.has(callback)) {
      const wrappedCallback = this.listeners.get(callback);
      document.removeEventListener(event, wrappedCallback);
      this.listeners.delete(callback);
    }
  },
};

export default eventBus;
